export default __webpack_public_path__ + "static/media/kep1.53c38920.jpg";